import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { isHeroMobileViewport } from '../utils/heroMobile';

gsap.registerPlugin(ScrollTrigger);

export function useHeroScrollEffects(heroRef, reducedMotion, introReady) {
  useEffect(() => {
    const hero = heroRef.current;
    if (!hero || reducedMotion || !introReady || isHeroMobileViewport()) return undefined;

    const bg = hero.querySelector('.rihen-hero-bg');
    const scrim = hero.querySelector('.rihen-hero-scrim');
    const grid = hero.querySelector('.rihen-hero-grid');
    const pitch = hero.querySelector('.rihen-hero-panel--pitch');
    const portrait = hero.querySelector('.rihen-hero-panel--portrait');
    const scrollCue = hero.querySelector('.rihen-scroll-cue');

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: 1.4,
        },
      });

      if (pitch) gsap.set(pitch, { filter: 'none' });
      if (portrait) gsap.set(portrait, { filter: 'none' });

      tl.to(bg, { y: 60, ease: 'none' }, 0)
        .to(scrim, { opacity: 1, ease: 'none' }, 0)
        .to(pitch, { y: -95, opacity: 0, scale: 0.96, filter: 'none', ease: 'none' }, 0)
        .to(portrait, { y: -55, opacity: 0, scale: 0.94, filter: 'none', ease: 'none' }, 0)
        .to(scrollCue, { opacity: 0, y: 16, ease: 'none' }, 0);

      ScrollTrigger.create({
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.4,
        onUpdate: (self) => {
          if (grid) {
            grid.style.setProperty('--hero-scroll', self.progress.toFixed(3));
          }
        },
      });
    }, hero);

    return () => ctx.revert();
  }, [heroRef, reducedMotion, introReady]);
}

export default useHeroScrollEffects;
